import React from 'react';
import { SurveyDefinition, SurveyStepDefinition } from '../../../types/Survey';

export interface SurveyStepContext {
    mode: "Design" | "Preview" | "Survey";
    surveyDefinition: SurveyDefinition;
    stepDefinition: SurveyStepDefinition;
}

export const SurveyStepContext = React.createContext<SurveyStepContext | null>(null);
